import React from "react";

import {
  crossSellContainerBaseStyle,
  crossSellLogoContainerBaseStyle,
  featuredPartnerPillStyle,
  crossSellContentContainerBaseStyle,
  crossSellLogoImageContainerBaseStyle,
  crossSellActionLineContainerStyle,
} from "./crossSellBase.css";
import { Button, Text } from "@puzzle/ve";
import { vars } from "@puzzle/theme";
import { Link } from "components/common/Link";

export type CrossSellActionProps = {
  text: string;
  link: string;
  external: boolean;
  buttonVariant?: React.ComponentProps<typeof Button>["variant"];
};

export type CrossSellBaseProps = {
  logo: React.ReactNode;
  title: string;
  description: string;
  line1Actions?: CrossSellActionProps[];
  line2Actions?: CrossSellActionProps[];
  line3Actions?: CrossSellActionProps[];
};

const buttonStyleOverride = {
  paddingLeft: vars.space["2"],
  paddingRight: vars.space["2"],
};

export const CrossSellBase = ({
  logo,
  title,
  description,
  line1Actions,
  line2Actions,
  line3Actions,
}: CrossSellBaseProps) => {
  return (
    <div className={crossSellContainerBaseStyle}>
      <div className={crossSellLogoContainerBaseStyle}>
        <div className={featuredPartnerPillStyle}>Featured partner</div>
        <div className={crossSellLogoImageContainerBaseStyle}>{logo}</div>
      </div>
      <div className={crossSellContentContainerBaseStyle}>
        <Text variant="heading2" weight="bold" color="neutral-highlight">
          {title}
        </Text>
        <Text
          color="neutral-subdue"
          weight="normal"
          lineHeight="bodyM"
          style={{ textAlign: "center" }}
        >
          {description}
        </Text>
        {line1Actions && <CrossSellActionLine lineActions={line1Actions} />}
        {line2Actions && <CrossSellActionLine lineActions={line2Actions} />}
        {line3Actions && <CrossSellActionLine lineActions={line3Actions} />}
      </div>
    </div>
  );
};

const CrossSellActionLine = ({ lineActions }: { lineActions: CrossSellActionProps[] }) => {
  return (
    <div className={crossSellActionLineContainerStyle}>
      {lineActions.map((action) => (
        <CrossSellAction key={action.link} {...action} />
      ))}
    </div>
  );
};

const CrossSellAction = ({ link, text, external, buttonVariant }: CrossSellActionProps) => {
  if (buttonVariant) {
    // button styled actions
    return (
      <Link external={external} href={link}>
        <Button style={buttonStyleOverride} size="large" variant={buttonVariant}>
          {text}
        </Button>
      </Link>
    );
  }
  return (
    // link styled actions
    <Link external={external} href={link} color="text-link-base" hoverColor="text-link-highlight">
      {text}
    </Link>
  );
};
